export type ClassScopeMarkField = 'ApplyLateLimit' | 'ApplyAbsenceLimit';

export interface LatenessScopeClass {
  SchoolClassId: string;
  Name: string;
  GradeLevelName: string | null;
  ShiftName: string | null;
}

export interface LatenessScopeRow extends LatenessScopeClass {
  CourseShift: string;
  ActiveEnrollmentCount: number | null;
}

export interface ODataCollection<T> {
  value: T[];
  '@odata.count'?: number;
}

export interface LatenessScopeState {
  scopeRows: LatenessScopeRow[] | null;
  markedClasses: number;
  totalClasses: number;
  studentsWithRule: number;
}

export const initialLatenessScopeState: LatenessScopeState = {
  scopeRows: null,
  markedClasses: 0,
  totalClasses: 0,
  studentsWithRule: 0,
};
